import { render } from "./DeliveryConfirm.vue?vue&type=template&id=10c1a836&scoped=true"
import script from "./DeliveryConfirm.vue?vue&type=script&lang=js"
export * from "./DeliveryConfirm.vue?vue&type=script&lang=js"

import "./DeliveryConfirm.vue?vue&type=style&index=0&id=10c1a836&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10c1a836"

export default script